export function footerFunc() {
}